import React from 'react';

import './HeroIcon.scss';

HeroIcon.defaultProps = {
    align: 'left',
    size: 'l',
};

function HeroIcon(props) {
    let mod_class = [
        'HeroIcon',
        props.onClick ? 'cursor-pointer' : '',
        props.align !== undefined ? 'align-' + props.align : '',
        props.size !== undefined ? 'size-' + props.size : '',
        props.theme !== undefined ? 'theme-' + props.theme : '',
        props.inactive !== undefined ? 'is-inactive' : '',
    ];
    mod_class = mod_class.join(' ');

    return (
        <div
            className={mod_class}
            onClick={() => props.onClick && props.onClick()}
        >
            {props.children}
        </div>
    );
}

export default HeroIcon;
